import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  updateDoc,
  doc
} from "firebase/firestore";
import { db } from "../config";
import NavBar from "./NavBar";

export default function AdminCompoundInvest() {
  const [investments, setInvestments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [updatingId, setUpdatingId] = useState(null);

  useEffect(() => {
    fetchInvestments();
  }, []);

  const fetchInvestments = async () => {
    setLoading(true);
    try {
      const snap = await getDocs(collection(db, "compoundInvest"));
      const data = snap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));
      setInvestments(data);
    } catch (err) {
      console.error("Error fetching investments:", err);
    }
    setLoading(false);
  };

  const handleStatusUpdate = async (id, newStatus) => {
    setUpdatingId(id);
    try {
      await updateDoc(doc(db, "compoundInvest", id), {
        status: newStatus
      });
      setInvestments((prev) =>
        prev.map((item) =>
          item.id === id ? { ...item, status: newStatus } : item
        )
      );
    } catch (err) {
      console.error("Status update failed:", err);
    }
    setUpdatingId(null);
  };

  return (
    <div className="page">
      {/* Main Header Nav */}
      <nav className="main-header navbar navbar-expand navbar-white navbar-light">
        <ul className="navbar-nav">
          <li className="nav-item">
            <a className="nav-link" data-widget="pushmenu" href="#" role="button">
              <i className="fas fa-bars" />
            </a>
          </li>
        </ul>
      </nav>

      <NavBar />

      <div className="container py-4">
        <h2 className="mb-4 text-center">All Compound Investments</h2>
        {loading ? (
          <div className="text-center">Loading investments...</div>
        ) : investments.length === 0 ? (
          <div className="alert alert-warning text-center">No investments found.</div>
        ) : (
          <div className="table-responsive">
            <table className="table table-bordered table-hover">
              <thead className="table-light">
                <tr>
                  <th>Email</th>
                  <th>Plan</th>
                  <th>Amount ($)</th>
                  <th>Pay Type</th>
                  <th>Status</th>
                  <th>Start</th>
                  <th>End</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {investments.map((inv) => (
                  <tr key={inv.id}>
                    <td>{inv.email}</td>
                    <td>{inv.plan}</td>
                    <td>${inv.amount}</td>
                    <td>{inv.paytype}</td>
                    <td>
                      <span
                        className={`badge bg-${
                          inv.status === "active"
                            ? "success"
                            : inv.status === "completed"
                            ? "primary"
                            : "secondary"
                        }`}
                      >
                        {inv.status}
                      </span>
                    </td>
                    <td>{inv.startAt?.toDate?.().toLocaleDateString() || "N/A"}</td>
                    <td>{inv.endAt ? new Date(inv.endAt).toLocaleDateString() : "N/A"}</td>
                    <td>
                      <select
                        className="form-select"
                        value={inv.status}
                        disabled={updatingId === inv.id}
                        onChange={(e) =>
                          handleStatusUpdate(inv.id, e.target.value)
                        }
                      >
                        <option value="active">Active</option>
                        <option value="completed">Completed</option>
                        <option value="pending">Pending</option>
                      </select>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <footer className="footer bg-light py-3 text-center">
        <span className="text-muted">© 2025 Admin Dashboard</span>
      </footer>
    </div>
  );
}
